/**
 * 테마 정의 파일
 * showcase 라우터 파라미터에 따라 적용될 테마 설정
 *
 * [새 테마 추가 방법]
 * 1. themes 객체에 showcase 이름으로 새 항목 추가
 * 2. router/index.js의 showcase 정규식에 이름 추가: (xi|soldoc|새이름)
 */

const themes = {
  xi: {
    main: '#002941',
    sub1: '#F0F1F4',
    sub2: '#D8D4CD',
    sub3: '#FFFFFF',
    font: 'Pretendard'
  },
  soldoc: {
    main: '#008DEF',
    sub1: '#FFFFFF',
    sub2: '#F3F5F8',
    sub3: '#FFFFFF',
    font: 'Pretendard'
  }, // DCE3AE FFFFFB 0F171B
  seoulone: {
    main: '#0F1819',
    sub1: '#EEEDE2',
    sub2: '#FFFFFB',
    sub3: '#FFFFFB',
    font: 'Pretendard'
  },
  lynn: {
    main: '#353D44',
    sub1: '#E2DDD9',
    sub2: '#FFFFFF',
    sub3: '#FFFFFF',
    font: 'Pretendard'
  },
  bodyfriend: {
    main: '#1d1d1d',
    sub1: '#FFFFFF',
    sub2: '#FFFFFF',
    sub3: '#FFFFFF',
    font: 'Pretendard'
  },
  honorsville: {
    main: '#0F2244',
    sub1: '#FFFFFF',
    sub2: '#FFFFFF',
    sub3: '#FFFFFF',
    font: 'Pretendard'
  },
  championscity: {
    main: '#B9955A',
    sub1: '#FFFFFF',
    sub2: '#FFFFFF',
    sub3: '#FFFFFF',
    font: 'Pretendard'
  }
  // 새 테마 추가 예시:
  // newbrand: {
  //   color: '#FF5722',
  //   font: '"Pretendard", sans-serif'
  // }
}

const defaultTheme = 'xi'

export function getTheme(showcaseName) {
  return themes[showcaseName] || themes[defaultTheme]
}

export function themeToCssVars(theme) {
  return {
    '--theme-main': theme.main,
    '--theme-sub1': theme.sub1,
    '--theme-sub2': theme.sub2,
    '--theme-sub3': theme.sub3,
    '--theme-font': theme.font
  }
}

export { themes, defaultTheme }
export default themes



// WEBPACK FOOTER //
// ./src/themes/index.js